module.exports = __webpack_public_path__ + "static/emm-010-c3941444171825ea26a67644a6904251.jpg";